/**
 * Utility function to access global scope. Added to make testing easier.
 */
export const getWindow = () => window;